const translations = {
    addressLineOne: 'Address Line 1',
    addressLineTwo: 'Address Line 2',
    city: 'City',
    companyName: 'Company Name',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    state: 'State',
    zipCode: 'Zip Code'
};

export default translations;
